module.exports = __webpack_public_path__ + "static/img/Marcus-Bontempelli.cafa94a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Marcus-Bontempelli.jpg
// module id = e1T9
// module chunks = 0